<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="M14.674 12.844a1 1 0 0 0 0-1.688L6.537 5.978A1 1 0 0 0 5 6.822v10.356a1 1 0 0 0 1.537.844l8.137-5.178Z"
  />
  <rect width="2" height="14" x="17" y="5" [attr.fill]="fillColor" rx="1" />
</svg>
